import { render, staticRenderFns } from "./NewEmp.vue?vue&type=template&id=31937723&"
import script from "./NewEmp.vue?vue&type=script&lang=js&"
export * from "./NewEmp.vue?vue&type=script&lang=js&"
import style0 from "./NewEmp.vue?vue&type=style&index=0&id=31937723&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports